export const ContentTypes = ['BLOG_POST', 'LISTING_PAGE', 'LANDING_PAGE', 'SITE_PAGE', 'KNOWLEDGE_ARTICLE'];